/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const split = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.133 13.6 15 11.733l-1.867-1.866M15 11.733l-3.267.002C9.4 11.735 7.533 8 7.533 8m5.6-1.868L15 4.267 13.133 2.4M15 4.267h-3.267c-2.333 0-4.2 3.734-4.2 3.734m0 0L1 8"
    />
  </svg>
)
export default split
